import { FormControlLabel, Grid, Typography } from "@mui/material";
import AcxExpansion from "components/UI/AcxExpansion";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxSwitch from "components/UI/AcxSwitch";
import React from "react";
import { KboFlowWorkflowInput } from "services/KboFlowSubscriptionsService";

export const DEFAULT_KBO_FLOW_WORKFLOW_INPUT: KboFlowWorkflowInput = {
    targetQuestionCount: 3,
    maxQuestionsToPursue: 1,
    ignoreHistory: false,
};

export const isKboFlowWorkflowInputValid = (
    value: KboFlowWorkflowInput,
): boolean =>
    Number.isInteger(value.targetQuestionCount) &&
    value.targetQuestionCount > 0 &&
    Number.isInteger(value.maxQuestionsToPursue) &&
    value.maxQuestionsToPursue > 0;

type Props = {
    idPrefix: string;
    value: KboFlowWorkflowInput;
    onChange: (value: KboFlowWorkflowInput) => void;
    advancedChildren?: React.ReactNode;
};

export function KboFlowWorkflowInputFields({
    idPrefix,
    value,
    onChange,
    advancedChildren,
}: Props) {
    const update = <K extends keyof KboFlowWorkflowInput>(
        key: K,
        nextValue: KboFlowWorkflowInput[K],
    ) => onChange({ ...value, [key]: nextValue });

    return (
        <>
            <Grid item>
                <AcxMainTextField
                    id={`${idPrefix}-target-question-count`}
                    labelText="Target Question Count"
                    type="number"
                    value={value.targetQuestionCount}
                    onChange={(event) =>
                        update(
                            "targetQuestionCount",
                            Number(event.target.value),
                        )
                    }
                    inputProps={{ min: 1, step: 1 }}
                    required
                />
            </Grid>
            <Grid item>
                <AcxMainTextField
                    id={`${idPrefix}-max-questions-to-pursue`}
                    labelText="Max Questions To Pursue"
                    type="number"
                    value={value.maxQuestionsToPursue}
                    onChange={(event) =>
                        update(
                            "maxQuestionsToPursue",
                            Number(event.target.value),
                        )
                    }
                    inputProps={{ min: 1, step: 1 }}
                    required
                />
            </Grid>
            <Grid item>
                <FormControlLabel
                    control={
                        <AcxSwitch
                            checked={value.ignoreHistory}
                            onChange={(event) =>
                                update("ignoreHistory", event.target.checked)
                            }
                        />
                    }
                    label="Ignore Run History"
                />
            </Grid>
            {advancedChildren && (
                <Grid item>
                    <AcxExpansion
                        header={
                            <Typography sx={{ fontWeight: 600 }}>
                                Advanced
                            </Typography>
                        }
                        body={
                            <Grid
                                container
                                spacing={2}
                                direction="column"
                                sx={{ pt: 2 }}
                            >
                                {advancedChildren}
                            </Grid>
                        }
                    />
                </Grid>
            )}
        </>
    );
}
